<template>
  <div :key="refresh_key">
    <!-- *** Naziv tvrtke **** -->
    <form-input
      :invalid="invalid_elements.tvrtka"
      label="Naziv tvrtke"
      id="tvrtka"
      ref="nazivTvrtke"
      required="required"
      :base="pravna.tvrtka"
    ></form-input>
    <!-- OIB -->
    <form-input label="OIB" id="oib" ref="OIB" :base="pravna.oib"></form-input>

     <!-- *** Email *** -->
    <form-input-multiple :base="pravna.email_list" ref="email" :name="'email'" :label="'Email'" :placeholder="'Unesite novu email adresu'" />
    <!-- *** Broj telefona *** -->
    <form-input-multiple :base="pravna.tel_br_list" ref="telefon" :name="'telefon'" :label="'Broj telefona'" :placeholder="'Unesite novi broj telefona'" />
    <!-- *** Web stranica *** -->
    <form-input-multiple :base="pravna.web_list" ref="stranica" :name="'stranica'" :label="'Web stranica'" :placeholder="'Unesite novu web stranicu'" />
    
    
  <div class="form-divider"></div>
    <!-- *** Adresa **** -->
    <adresa-element ref="adresaElement" :base="pravna.adrese_list" />
    <div class="form-divider"></div>
    <!-- *** INDUSTRIJA **** -->
    <form-drop-down
      label="Industrija"
      id="industrija"
      ref="industrija"
      :dropImport="industrija"
      :base="pravna.industrija_id.ID"
    ></form-drop-down>

    <!-- *** Godišnji prihod **** -->
    <form-input
      label="Godišnji prihod"
      id="godisnji-prihod"
      ref="godisnjiPrihod"
      :base="pravna.god_prihod"
    ></form-input>
    <!-- *** Tip izvora **** -->
    <form-drop-down
      label="Tip izvora"
      id="tip-izvor"
      ref="tipIzvor"
      :dropImport="tipovi_izvora"
      :base="pravna.id_tip_izvora.ID"
    ></form-drop-down>
    <form-autocomplete-single
      :invalid="invalid_elements.izvor"
      :style="pravna.id_tip_izvora.ID <= 3 ? 'display:flex' : 'display:none'"
      :name="'imeIzvora'"
      :placeholder="pravna.id_tip_izvora.ID == 1 ? 'Odaberite fizičku osobu' : pravna.id_tip_izvora.ID == 2 ? 'Odaberite pravnu osobu' : 'Odaberite člana tima'"
      :type="'Izvor'"
      :id="'izvor'"
      ref="imeIzvora"
      :items="pravna.id_tip_izvora.ID == 1 ? fizicke : pravna.id_tip_izvora.ID == 2 ? pravne : clanovi"
    ></form-autocomplete-single>
    <!-- *** Izvor izvan sustava **** -->
    <form-input
      :invalid="invalid_elements.custom_ime_izvora"
      :style="pravna.id_tip_izvora.ID == 4 ? 'display:flex' : 'display:none'"
      label="Izvor izvan sustava "
      id="custom-izvor"
      ref="customIzvor"
      :base="pravna.custom_ime_izvora"
    ></form-input>
    <!-- *** Drugi kontakt ****
    <form-input
      label="Drugi kontakt"
      id="drugi-kontakt"
      ref="drugiKontakt"
    ></form-input> -->
    <!-- *** Radno vrijeme **** -->
    <form-input
      label="Radno vrijeme"
      id="radno-vrijeme"
      ref="radnoVrijeme"
    ></form-input>
    <!-- *** OPIS **** -->
    <form-textarea label="Opis" id="opis" ref="opis" :base="pravna.opis"></form-textarea>
  </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import adresaElement from "@/components/formElements/adresaElement.vue";
import formAutocompleteSingle from '@/components/formElements/formAutocompleteSingle.vue'
import formInputMultiple from '@/components/formElements/formInputMultiple.vue'
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";

import $ from "jquery";
import FormInputMultiple from '../formElements/formInputMultiple.vue';

export default {
  data() {
    return {
      refresh_key: 1,
      pravna: {
        tvrtka: "",
        oib: "",
        email_list: [],
        tel_br_list: [],
        adrese_list: [],
        web_list: [],
        industrija_id:{ID:1},
        god_prihod: "",
        id_tip_izvora:{ID:5},
        izvor_osoba: "",
        custom_ime_izvora: "",
        radno_vrijeme: "",
        opis: "",
      },
    };
  },
    async created() {
    let route_name = this.$router.history.current.name;
    if (route_name === "LegalPersonEdit") {
     osoba.getPravna(this.$router.history.current.params.oib)
        .then(async (resp) => {
               console.log(resp.data)

          console.log("OSOBA:")
          const pravno_tijelo =resp.data;
          console.log(pravno_tijelo)
          this.$refs.nazivTvrtke.$data.value = pravno_tijelo.ime == null ? '':pravno_tijelo.ime;
          this.$refs.OIB.$data.value = pravno_tijelo.oib == null ? '':pravno_tijelo.oib
          this.$refs.industrija.$data.ID = pravno_tijelo.industrija_id.id;
          this.$refs.godisnjiPrihod.$data.value = pravno_tijelo.god_prihod == null ? '':pravno_tijelo.god_prihod;
          this.$refs.tipIzvor.$data.ID = pravno_tijelo.id_tip_izvora.id_tip_izvora;
          this.$refs.adresaElement.$data.lista_adresa = pravno_tijelo.adresa == null ? [] : pravno_tijelo.adresa;

          this.$refs.email.$data.values = pravno_tijelo.email_list
          this.$refs.telefon.$data.values = pravno_tijelo.tel_br_list;
          this.$refs.stranica.$data.values = pravno_tijelo.web_list;
          this.$refs.customIzvor.$data.value = pravno_tijelo.custom_ime_izvora == null ? '':pravno_tijelo.custom_ime_izvora;
          this.$refs.radnoVrijeme.$data.value = pravno_tijelo.radno_vrijeme == null ? '': pravno_tijelo.radno_vrijeme;
          this.$refs.opis.$data.value = pravno_tijelo.opis == null ? '' : pravno_tijelo.opis;
          //odvjetnik_odvjetnikTopravna_osoba_src_team_uid
          switch (pravno_tijelo.id_tip_izvora.id_tip_izvora) {
            case 1:
              this.$refs.imeIzvora.$data.results_final.uid =pravno_tijelo.izvor_fizicka.uid;
              this.$refs.imeIzvora.$data.results_final.name = pravno_tijelo.izvor_fizicka.ime +' '+pravno_tijelo.izvor_fizicka.prezime
              break;
            case 2:
              this.$refs.imeIzvora.$data.results_final.uid =pravno_tijelo.izvor_pravna.uid;
              this.$refs.imeIzvora.$data.results_final.name = pravno_tijelo.izvor_pravna.ime
              break;
            case 3:
              this.$refs.imeIzvora.$data.results_final.uid =pravno_tijelo.izvor_clan_tima.uid;
              this.$refs.imeIzvora.$data.results_final.name = pravno_tijelo.izvor_clan_tima.ime +' '+pravno_tijelo.izvor_clan_tima.prezime
              break;
            default:
              break;
          }
          this.$emit("finished");
          
        });
    }
  },
  mounted() {
    this.$refs.tipIzvor.$data.ID = 5;
    this.pravna.tvrtka = this.$refs.nazivTvrtke.$data;
    this.pravna.oib = this.$refs.OIB.$data;

    this.pravna.industrija_id = this.$refs.industrija.$data;
    this.pravna.god_prihod = this.$refs.godisnjiPrihod.$data;
    this.pravna.id_tip_izvora = this.$refs.tipIzvor.$data;
    this.pravna.adrese_list = this.$refs.adresaElement.$data;
    this.pravna.izvor_osoba = this.$refs.imeIzvora.$data;
    this.pravna.custom_ime_izvora = this.$refs.customIzvor.$data;
    this.pravna.email_list = this.$refs.email.$data;
    this.pravna.tel_br_list = this.$refs.telefon.$data;
    this.pravna.web_list = this.$refs.stranica.$data;

    this.pravna.radno_vrijeme = this.$refs.radnoVrijeme.$data;
    this.pravna.opis = this.$refs.opis.$data;
  },
  props: ["industrija", "tipovi_izvora","fizicke", "clanovi","pravne","invalid_elements"],
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "adresa-element":adresaElement,
    "form-autocomplete-single":formAutocompleteSingle,
    "form-input-multiple":formInputMultiple,
  },
};
</script>
